export default {
  page: function () {
    this.loadPayables()
  }
}
